import { MapType } from '@capacitor/google-maps';
import { LatLng } from '@capacitor/google-maps/dist/typings/definitions';
import { MSLatLng, MSMapType } from '../../models/map.model';

export function msLatLngToLatLng(msLatLng: MSLatLng): LatLng {
  const latLng: LatLng = {
    lat: msLatLng.lat,
    lng: msLatLng.lng
  };

  return latLng;
}

export function msMapTypeToMapType(mapType: MSMapType): MapType {
  switch (mapType) {
    case MSMapType.HYBRID:
      return MapType.Hybrid;
    case MSMapType.NORMAL:
      return MapType.Normal;
    case MSMapType.NONE:
      return MapType.None;
    case MSMapType.SATELLITE:
      return MapType.Satellite;
    case MSMapType.TERRAIN:
      return MapType.Terrain;
    default:
      throw new Error('Unknown map type');
  }
}
